module.exports = __webpack_public_path__ + "static/media/CIMG4966a.582922b7.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/images/explore/fluvial/CIMG4966a.JPG
// module id = 108
// module chunks = 0